import useAttachedElementsStore from '../stores/useAttachedElementsStore';

export const useAttachedElements = () => {
  const store = useAttachedElementsStore.getState();
  return {
    getCoordsByAttachMode: store.getCoordsByAttachMode,
    getAttachedSourcePosition: store.getAttachedSourcePosition,
    moveAttachedSources: store.moveAttachedSources,
    updateSourceAttachedOffset: store.updateSourceAttachedOffset,
    attachToElement: store.attachToElement,
    detachElement: store.detachElement,
    updateAttachedPosition: store.updateAttachedPosition,
    distributeGroup: store.distributeGroup,
    reDistributeGroup: store.reDistributeGroup,
    destroyDistributedGroup: store.destroyDistributedGroup,
  };
};
